export default {
  insertYcCompanyInfo: '/ygsjzs/ycCompanyInfo/insertYcCompanyInfo',
  updateYcCompanyInfo: '/ygsjzs/ycCompanyInfo/updateYcCompanyInfo',
  approveYcCompanyInfo: '/ygsjzs/ycCompanyInfo/approveYcCompanyInfo',
  deleteYcCompanyInfo: '/ygsjzs/ycCompanyInfo/deleteYcCompanyInfo',
  selectYcCompanyInfoByCompanyId: '/ygsjzs/ycCompanyInfo/selectYcCompanyInfoByCompanyId',
  selectYcCompanyInfoByPage: '/ygsjzs/ycCompanyInfo/selectYcCompanyInfoByPage'
}
